import React, { Component } from 'react';
import momentjs from 'moment-jalaali';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import {
  flightBookingRoutes,
  numberWithCommas,
} from '../../../../utils/consts';
import {
  returnDirection,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import {
  FlightDetailCard,
  MobileFlightInfoBooking,
  MobileFlightDetailsBooking,
  BookingPriceDetails,
  Modal,
  PassengerTable,
  Input,
  Button,
  Toast,
} from '../../../../component';
import { InfoCircleIcon, ChevronDownIcon, InfoCircleFillIcon } from '~svg';
import { colors } from '../../../../utils/consts/color-variable';
import { ticketApi } from '../../../../services/apis';
import OtherRequest from '../../../../domain/profile/profile/bookingFlights/otherRequest';
import './mainFlightCard.scss';

let parsedQueryStr = {};
class MainFlightCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: false,
      showPriceDetail: false,
      perviousPassengersModal: false,
      showAlert: false,
      onlineSupport: false,
      loadingContent: false,
      perviousPassengersModalData: null,
      alertMessage: 'ticket.indertSuccessFully',
      toastState: 'success',
      onlineSupportData: '',
      messageContent: '',
      subjectKey: '',
    };
  }
  renderPerviousPassengerslink = () => {
    return (
      <Modal
        isOpen={this.state.perviousPassengersModal}
        onClose={() =>
          this.setState({
            perviousPassengersModal: false,
            perviousPassengersModalData: null,
          })
        }
        title={this.props.intl.formatMessage({ id: 'booking.passengerinfo' })}
        modalWidth="col-12 col-md-10"
      >
        <PassengerTable
          passengerLst={this.props?.item?.passengers}
          direction={this.props.language.direction}
          className="text-white "
          bgClassName="bg-white shadow"
        />
      </Modal>
    );
  };
  renderColumn = (titleValue, value, isNumber, valueClass, type, id) => {
    const { showPassengerDetail, showPriceDetail } = this.state;
    return (
      <div className="flex-column d-flex font-weight-bold p-0 justify-content-start align-items-start col-xl-2 col-6">
        <div
          className={`d-flex flex-column text-uppercase font-weight-bold text-third font-smaller p-0 col- justify-content-center align-items-start`}
        >
          <span className="text-third">{titleValue}</span>
          <div
            className={`w-100 text-uppercase font-smaller text-center font-weight-bold  pt-1 align-items-center  justify-content-start d-flex text-dark ${valueClass}`}
          >
            <div className="d-flex align-items-center pt-1">
              {isNumber ? numberWithCommas(value) : value}
            </div>
            {type === 'details' && (
              <div
                className="d-flex align-items-center px-1 justify-content-center cursor-pointer linkableDiv"
                id={`showPassengerDetails-${id}`}
                onMouseEnter={() => {
                  this.setState({ showPassengerDetail: true });
                }}
                onMouseLeave={() => {
                  this.setState({ showPassengerDetail: false });
                }}
                onClick={() =>
                  this.setState({
                    perviousPassengersModal: true,
                    perviousPassengersModalData: this.props.item?.passengers,
                  })
                }
              >
                <InfoCircleIcon color={colors.primary} size={18} />
              </div>
            )}
            {type === 'price' && (
              <div className="d-flex align-items-center justify-content-center flex-grow-1 p-0">
                <div
                  className="d-flex align-items-center px-1 justify-content-center cursor-pointer linkableDiv text-primary"
                  onMouseOver={() => {
                    this.setState({ showPriceDetail: true });
                  }}
                  onMouseLeave={() => {
                    this.setState({ showPriceDetail: false });
                  }}
                  id={`showPriceDetails-${id}`}
                >
                  {showPriceDetail ? (
                    <InfoCircleFillIcon color={colors.primary} size={18} />
                  ) : (
                    <InfoCircleIcon color={colors.primary} size={18} />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderButtons = (item, index) => {
    let { direction } = this.props.language;
    return (
      <div className="d-flex w-100 text-dark mx-0 mt-2 px-0 py-3 mt-4 card d-flex justify-content-start default-border-radius-small">
        <div className="d-flex w-100 justify-content-around px-0 ">
          <div
            onClick={() => this.flightInvoice(item)}
            className={`d-flex text-underline border-0 text-uppercase bg-transparent text-dark cursor-pointer  ${
              direction === 'rtl' ? 'font-smaller' : 'font-tiny'
            } justify-content-center align-items-center font-weight-bold  outline-none`}
          >
            <FormattedMessage id="booking.paynow" />
          </div>
          <button
            name={`send-problem-${index}`}
            id={`send-problem-${index}`}
            className={`d-flex text-underline border-0 text-uppercase bg-transparent text-dark  justify-content-center align-items-center cursor-pointer  ${
              direction === 'rtl' ? 'font-smaller' : 'font-tiny'
            } font-weight-bold  outline-none`}
            onClick={() =>
              this.setState({
                onlineSupportData: item._id,
                onlineSupport: true,
              })
            }
          >
            <FormattedMessage id="booking.sendproblem" />
          </button>
        </div>
      </div>
    );
  };

  flightInvoice = (item) => {
    // create querry string and redirect to flight invoice
    parsedQueryStr['ad'] = item?.flights.adultCount;
    parsedQueryStr['ch'] = item?.flights.childCount;
    parsedQueryStr['in'] = item?.flights.infantCount;
    item?.flights.itineraries.map((fly, index) => {
      parsedQueryStr[`d${index + 1}`] =
        fly.flights[0].departureDateTime.split('T')[0];
      parsedQueryStr[`fr${index + 1}`] =
        fly.flights[index].departureAirport.code;
      parsedQueryStr[`to${index + 1}`] = fly.flights[index].arrivalAirport.code;
      parsedQueryStr['dl'] = true;
      parsedQueryStr['ft'] = item?.flights.flightType;
      parsedQueryStr['ol'] = false;
      parsedQueryStr['token'] = item._id;
    });
    sessionStorage.removeItem('selectFlight');
    sessionStorage.setItem('selectFlight', JSON.stringify(item?.flights));
    this.props.navigate(
      `${flightBookingRoutes.flightInvoice}?${new URLSearchParams(
        parsedQueryStr,
      ).toString()}`,
    );
  };

  sendOtherRequest = (bookingId) => {
    this.setState({ loadingContent: true });
    try {
      let { messageContent, subjectKey } = this.state;
      if (messageContent && subjectKey)
        ticketApi
          .createTicket({
            data: {
              _id: '0',
              bookingId,
              subject: subjectKey,
              message: messageContent.substring(3, messageContent.length - 4),
            },
          })

          .then((response) => {
            if (response.status === 200) {
              this.setState({
                onlineSupport: false,
                onlineSupportData: null,
                showAlert: true,
                alertMessage: 'ticket.indertSuccessFully',
                toastState: 'success',
              });
            }
          })
          .catch((reject) => {});
    } catch (error) {
      this.setState({
        showAlert: true,
        alertMessage: 'booking.servererror',
        toastState: 'danger',
      });
    } finally {
      this.setState({ loadingContent: false });
    }
  };

  render() {
    const {
      showDetail,
      showPriceDetail,
      onlineSupportData,
      onlineSupport,
      showAlert,
      toastState,
      alertMessage,
      loadingContent,
    } = this.state;
    const {
      item,
      index,
      cardWidth,
      showLimitTime = false,
      language,
      intl,
      location,
    } = this.props;
    let priceList = [];
    let parsedQueryStr = Object.fromEntries(
      new URLSearchParams(location.search),
    );
    if (item && Object.entries(item)?.length) {
      item?.flights?.itineraries.forEach(() => {
        item?.passengers.forEach((passangerInfo) => {
          if (
            passangerInfo?.type === 'adult' &&
            priceList.filter((item) => item?.key === 'Adult').length === 0
          ) {
            priceList.push({ key: 'Adult', ...passangerInfo?.price });
            priceList.push({
              key: 'Total',
              ...passangerInfo?.totalPrice,
            });
          }
          if (
            passangerInfo?.type === 'child' &&
            priceList.filter((item) => item?.key === 'Child').length === 0
          ) {
            priceList.push({ key: 'Child', ...passangerInfo?.price });
            priceList.push({
              key: 'Total',
              ...passangerInfo?.totalPrice,
            });
          }
          if (
            passangerInfo?.type === 'infant' &&
            priceList.filter((item) => item?.key === 'Infant').length === 0
          ) {
            priceList.push({
              key: 'Infant',
              ...passangerInfo?.price,
            });
            priceList.push({
              key: 'Total',
              ...passangerInfo?.totalPrice,
            });
          }
        });
        priceList.push({
          key: 'Total',
          TotalPrice: item?.totalPrice,

          Commission: item?.commission ? item?.commission : 0,
        });
      });
      if (item?.flights?.itineraries) {
        let { name, direction } = language,
          itineraries = item?.flights?.itineraries,
          orderDate = momentjs(new Date(item?.orderDate)),
          departDate = item.flights.itineraries[0].flights[0].departureDateTime,
          ticketTimeLimit = item.flights?.ticketTimeLimit
            ? momentjs(new Date(item.flights?.ticketTimeLimit + 'Z'))
            : '',
          shamsiTicketLimitTime =
            direction === 'rtl'
              ? ticketTimeLimit
                ? ticketTimeLimit.format('HH:mm jYYYY-jMM-jDD')
                : ''
              : '';
        let isExpired = ticketTimeLimit
          ? momentjs(ticketTimeLimit).isBefore(todayDate)
          : true;
        let todayDate = momentjs(new Date()).format('YYYY-MM-DD HH:mm');

        return (
          <div
            key={`mainFlight-${index}`}
            className={`mt-2 ${cardWidth ? cardWidth : 'col-11 p-0 '}`}
          >
            <Toast
              isOpen={showAlert}
              onClose={() => {
                this.setState({ showAlert: false });
              }}
              state={toastState}
              position="bottom"
              message={
                alertMessage
                  ? intl.formatMessage({
                      id: alertMessage,
                    })
                  : ''
              }
              direction={direction}
            />
            <Modal
              isOpen={onlineSupport}
              onClose={() =>
                this.setState({ onlineSupport: false, onlineSupportData: null })
              }
              title={this.props.intl.formatMessage({
                id: 'booking.sendproblem',
              })}
              titleClass="font-large"
              id={`onlineSupport`}
              // closeModal={this.closeModal}
            >
              <OtherRequest
                intl={intl}
                id={onlineSupportData}
                loading={loadingContent}
                handleSubmit={(e) => {
                  this.setState(
                    {
                      subjectKey: e.subjectKey,
                      messageContent: e.messageContent,
                    },
                    () => this.sendOtherRequest(onlineSupportData),
                  );
                }}
              />
            </Modal>
            <div
              className="card d-md-flex d-none flex-column align-items-center justify-content-center mx-3 mt-3  border-md default-border-radius-small"
              key={item?._id}
            >
              <div
                className={`card-body d-md-flex d-none py-2 px-3 w-100 align-items-center`}
              >
                <div className="col-">
                  <img
                    key={`img-${item?.flights?.itineraries?.[0]?.flights?.[0]?.operatingAirline?.code}`}
                    style={{
                      width: '35px',
                      height: '35px',
                    }}
                    className={`d-flex justify-content-center rounded-circle bg-white border mx-2`}
                    src={returnAirlineLogos(
                      item?.flights?.itineraries?.[0]?.flights?.[0]
                        ?.operatingAirline?.code,
                    )}
                    alt="flights"
                  />
                </div>
                <div className="flex-sm-fill d-flex justify-content-between flex-wrap px-md-3 px-sm-4 px-2">
                  {this.renderColumn(
                    `${
                      direction === 'rtl'
                        ? item?.flights?.itineraries?.[0]?.flights?.[0]
                            ?.operatingAirline?.name?.fa
                        : item?.flights?.itineraries?.[0]?.flights?.[0]
                            ?.operatingAirline?.name?.en
                    } ${intl.formatMessage({
                      id: 'booking.flights',
                    })}`,
                    returnDirection(itineraries, name),
                    false,
                    ``,
                  )}
                  {this.renderColumn(
                    `${item?.flights?.adultCount}
                    ${intl.formatMessage({
                      id: 'booking.Adult',
                    })}
                     ${item?.flights?.childCount}
                     ${intl.formatMessage({
                       id: 'booking.child',
                     })}
                    `,
                    `${item?.passengers?.[0]?.firstName} ${item?.passengers?.[0]?.lastName}`,
                    false,
                    ``,
                    'details',
                    item?._id,
                  )}
                  {this.renderColumn(
                    `${intl.formatMessage({
                      id: 'booking.invoice',
                    })} ${item?.invoiceNo}`,
                    `${
                      orderDate && direction === 'ltr'
                        ? orderDate.format('YYYY-MM-DD HH:mm')
                        : orderDate.format('HH:mm jYYYY-jMM-jDD')
                    }`,
                    false,
                  )}
                  {this.renderColumn(
                    `${intl.formatMessage({
                      id: 'booking.traveldatetime',
                    })}`,
                    orderDate &&
                      `${
                        direction === 'rtl'
                          ? momentjs(departDate, 'YYYY-MM-DD HH:mm')
                              .local('fa')
                              .format('HH:mm jYYYY-jMM-jDD ')
                          : `${departDate.split('T')[0]} - ${departDate
                              .split('T')[1]
                              .substring(0, 5)}`
                      }
                  `,
                    false,
                  )}
                  {this.renderColumn(
                    `${intl.formatMessage({
                      id: 'booking.totalamount',
                    })}`,
                    `${Math.round(item?.totalPrice / 10)} ${intl.formatMessage({
                      id: 'booking.toman',
                    })}`,
                    true,
                    '',
                    'price',
                    item?._id,
                  )}
                  {showLimitTime &&
                    this.renderColumn(
                      `${intl.formatMessage({
                        id: 'booking.tickettimelimit',
                      })}`,
                      language?.direction === 'rtl'
                        ? shamsiTicketLimitTime
                        : ticketTimeLimit.format('YYYY-MM-DD HH:MM'),
                      false,
                      `${isExpired ? 'text-danger' : 'text-third'}`,
                    )}
                </div>
                <div className="d-flex px-1 align-items-center justify-content-center">
                  <div
                    className="d-flex w-100 flex-column pointer justify-content-center text-third"
                    onClick={() => this.setState({ showDetail: !showDetail })}
                  >
                    <div className="d-flex justify-content-center align-items-center font-weight-bold font-smaller">
                      <FormattedMessage id="booking.details" />
                    </div>
                    <div className="d-flex justify-content-center align-items-center  px-1">
                      <ChevronDownIcon size={20} color="#aaacaf" />
                    </div>
                  </div>
                </div>
              </div>
              {showPriceDetail && (
                <div
                  className={`text-center col-9 position-absolute priceDetails price-view-position`}
                >
                  <BookingPriceDetails
                    priceList={priceList}
                    parsedQueryStr=""
                    item={item}
                    backgroundColor="#151a44"
                    border="solid 1px white"
                  />
                </div>
              )}

              {showDetail && (
                <FlightDetailCard
                  selectFlight={item?.flights}
                  currentFlight={item}
                  passengers={item?.passengers}
                  totalPrice={item?.totalPrice}
                />
              )}
            </div>
            <div
              className={`d-flex d-md-none flex-column align-items-center justify-content-center mx-3 mt-3 border-0 position-relative rounded ${
                showDetail ? 'bg-white' : ''
              }`}
            >
              {!showDetail ? (
                <div
                  className="d-flex w-100 flex-column mt-2 border-radius "
                  key={`mainFlight-${index}`}
                >
                  <div
                    key={`flighLst-${index}`}
                    className={`border-0 w-100 p-0 font-weight-bold text-left cursor-pointer`}
                    onClick={() => {
                      this.setState({
                        showDetail: true,
                      });
                    }}
                  >
                    <MobileFlightInfoBooking
                      index={index}
                      flightLength={1}
                      item={item}
                      totalPassenger={item?.passengers?.length}
                      returnShowDetailFlag={() => {}}
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex w-100 flex-column mt-2 border-0 booking"
                  key={`detail-${index}`}
                >
                  <div className="mb-1">
                    <MobileFlightDetailsBooking
                      list={item.itineraries}
                      name={name}
                      direction={language?.direction}
                      intl={intl}
                      flight={item}
                      isBooking={true}
                      totalPassenger={item?.passengers?.length}
                      parsedQueryStr={parsedQueryStr}
                      returnToBackTab={() =>
                        this.setState({ showDetail: !showDetail })
                      }
                      trackOrder={true}
                    />
                    {item?.status?.code === '02' && !isExpired && (
                      <div className="w-100 px-2">
                        {this.renderButtons(item, index)}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {this.renderPerviousPassengerslink()}
          </div>
        );
      }
    }
  }
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state?.user?.userInfo,
  };
}

export default injectIntl(
  connect(mapStateToProps, {})(withRouter(MainFlightCard)),
);
